__turbopack_context__.v({
  "button": "Clickables-module__HiOs8W__button",
  "danger": "Clickables-module__HiOs8W__danger",
  "navLink": "Clickables-module__HiOs8W__navLink",
  "navLinkActive": "Clickables-module__HiOs8W__navLinkActive",
  "onColorful": "Clickables-module__HiOs8W__onColorful",
  "primary": "Clickables-module__HiOs8W__primary",
  "primaryVariant": "Clickables-module__HiOs8W__primaryVariant",
  "pro": "Clickables-module__HiOs8W__pro",
  "secondary": "Clickables-module__HiOs8W__secondary",
  "secondaryVariant": "Clickables-module__HiOs8W__secondaryVariant",
  "tertiary": "Clickables-module__HiOs8W__tertiary",
  "tertiaryVariant": "Clickables-module__HiOs8W__tertiaryVariant",
});
